module.exports = __webpack_public_path__ + "img/x.5713e1fa.svg";